<template>
  <div class="refresh simple-click-hover" @click="refresh">
    <i class="el-icon-refresh"></i>
    <span>换一换</span>
  </div>
</template>

<script>
import refreshIcon from "@/assets/images/search/refresh.png";

export default {
  data() {
    return {
      refreshIcon,
    }
  },
  methods: {
    refresh() {
      this.$emit('refresh')
    }
  },
}
</script>

<style lang="less" scoped>
  .refresh {
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    color: @a-color-active;
    span {
      margin-left: 2px;
    }
  }
</style>
